import { useBreakpoints } from "@vueuse/core";
import { BreakpointsConstants, RawBreakpoints } from "../constants/BreakpointsContants";

export const breakpoints = useBreakpoints(RawBreakpoints);

export const biggerOrEqual2xl = breakpoints.greaterOrEqual(BreakpointsConstants["2xl"].key);
export const biggerOrEqualSm = breakpoints.greaterOrEqual(BreakpointsConstants["sm"].key);
export const biggerOrEqual5xl = breakpoints.greaterOrEqual(BreakpointsConstants["5xl"].key);
export const biggerOrEqualLg = breakpoints.greaterOrEqual(BreakpointsConstants["lg"].key);
